import React, { FC } from 'react';

import { IProps } from '../index';

export const DefectsCZoneList: FC<IProps> = ({ statistics }) => {
  return (
    <>
      {statistics && 'defectsCZoneCounts' in statistics && (
        <ul className='seg__statistics__list'>
          <li className='seg__statistics__item'>
            <p>C</p>
          </li>
          {statistics.defectsCZoneCounts.map((item, idx) => (
            <li key={idx} className='seg__statistics__item'>
              <p>{item}</p>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};
